var NKS_DEBUG = true;

;(function (window) {
    var transitions = {
            'transition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd',
            'MozTransition': 'transitionend',
            'OTransition': 'otransitionend'
        },
        elem = document.createElement('div');

    for (var t in transitions) {
        if (typeof elem.style[t] !== 'undefined') {
            window.transitionEnd = transitions[t];
            break;
        }
    }
    if (!window.transitionEnd) window.transitionEnd = false;
})(window);

eval(function (p, a, c, k, e, r) {
    e = function (c) {
        return (c < a ? '' : e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36))
    };
    if (!''.replace(/^/, String)) {
        while (c--) r[e(c)] = k[c] || e(c);
        k = [
            function (e) {
                return r[e]
            }
        ];
        e = function () {
            return '\\w+'
        };
        c = 1
    }
    ;
    while (c--)
        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
    return p
}('9 17={3i:\'0.1.3\',16:1e-6};l v(){}v.23={e:l(i){8(i<1||i>7.4.q)?w:7.4[i-1]},2R:l(){8 7.4.q},1u:l(){8 F.1x(7.2u(7))},24:l(a){9 n=7.4.q;9 V=a.4||a;o(n!=V.q){8 1L}J{o(F.13(7.4[n-1]-V[n-1])>17.16){8 1L}}H(--n);8 2x},1q:l(){8 v.u(7.4)},1b:l(a){9 b=[];7.28(l(x,i){b.19(a(x,i))});8 v.u(b)},28:l(a){9 n=7.4.q,k=n,i;J{i=k-n;a(7.4[i],i+1)}H(--n)},2q:l(){9 r=7.1u();o(r===0){8 7.1q()}8 7.1b(l(x){8 x/r})},1C:l(a){9 V=a.4||a;9 n=7.4.q,k=n,i;o(n!=V.q){8 w}9 b=0,1D=0,1F=0;7.28(l(x,i){b+=x*V[i-1];1D+=x*x;1F+=V[i-1]*V[i-1]});1D=F.1x(1D);1F=F.1x(1F);o(1D*1F===0){8 w}9 c=b/(1D*1F);o(c<-1){c=-1}o(c>1){c=1}8 F.37(c)},1m:l(a){9 b=7.1C(a);8(b===w)?w:(b<=17.16)},34:l(a){9 b=7.1C(a);8(b===w)?w:(F.13(b-F.1A)<=17.16)},2k:l(a){9 b=7.2u(a);8(b===w)?w:(F.13(b)<=17.16)},2j:l(a){9 V=a.4||a;o(7.4.q!=V.q){8 w}8 7.1b(l(x,i){8 x+V[i-1]})},2C:l(a){9 V=a.4||a;o(7.4.q!=V.q){8 w}8 7.1b(l(x,i){8 x-V[i-1]})},22:l(k){8 7.1b(l(x){8 x*k})},x:l(k){8 7.22(k)},2u:l(a){9 V=a.4||a;9 i,2g=0,n=7.4.q;o(n!=V.q){8 w}J{2g+=7.4[n-1]*V[n-1]}H(--n);8 2g},2f:l(a){9 B=a.4||a;o(7.4.q!=3||B.q!=3){8 w}9 A=7.4;8 v.u([(A[1]*B[2])-(A[2]*B[1]),(A[2]*B[0])-(A[0]*B[2]),(A[0]*B[1])-(A[1]*B[0])])},2A:l(){9 m=0,n=7.4.q,k=n,i;J{i=k-n;o(F.13(7.4[i])>F.13(m)){m=7.4[i]}}H(--n);8 m},2Z:l(x){9 a=w,n=7.4.q,k=n,i;J{i=k-n;o(a===w&&7.4[i]==x){a=i+1}}H(--n);8 a},3g:l(){8 S.2X(7.4)},2d:l(){8 7.1b(l(x){8 F.2d(x)})},2V:l(x){8 7.1b(l(y){8(F.13(y-x)<=17.16)?x:y})},1o:l(a){o(a.K){8 a.1o(7)}9 V=a.4||a;o(V.q!=7.4.q){8 w}9 b=0,2b;7.28(l(x,i){2b=x-V[i-1];b+=2b*2b});8 F.1x(b)},3a:l(a){8 a.1h(7)},2T:l(a){8 a.1h(7)},1V:l(t,a){9 V,R,x,y,z;2S(7.4.q){27 2:V=a.4||a;o(V.q!=2){8 w}R=S.1R(t).4;x=7.4[0]-V[0];y=7.4[1]-V[1];8 v.u([V[0]+R[0][0]*x+R[0][1]*y,V[1]+R[1][0]*x+R[1][1]*y]);1I;27 3:o(!a.U){8 w}9 C=a.1r(7).4;R=S.1R(t,a.U).4;x=7.4[0]-C[0];y=7.4[1]-C[1];z=7.4[2]-C[2];8 v.u([C[0]+R[0][0]*x+R[0][1]*y+R[0][2]*z,C[1]+R[1][0]*x+R[1][1]*y+R[1][2]*z,C[2]+R[2][0]*x+R[2][1]*y+R[2][2]*z]);1I;2P:8 w}},1t:l(a){o(a.K){9 P=7.4.2O();9 C=a.1r(P).4;8 v.u([C[0]+(C[0]-P[0]),C[1]+(C[1]-P[1]),C[2]+(C[2]-(P[2]||0))])}1d{9 Q=a.4||a;o(7.4.q!=Q.q){8 w}8 7.1b(l(x,i){8 Q[i-1]+(Q[i-1]-x)})}},1N:l(){9 V=7.1q();2S(V.4.q){27 3:1I;27 2:V.4.19(0);1I;2P:8 w}8 V},2n:l(){8\'[\'+7.4.2K(\', \')+\']\'},26:l(a){7.4=(a.4||a).2O();8 7}};v.u=l(a){9 V=25 v();8 V.26(a)};v.i=v.u([1,0,0]);v.j=v.u([0,1,0]);v.k=v.u([0,0,1]);v.2J=l(n){9 a=[];J{a.19(F.2F())}H(--n);8 v.u(a)};v.1j=l(n){9 a=[];J{a.19(0)}H(--n);8 v.u(a)};l S(){}S.23={e:l(i,j){o(i<1||i>7.4.q||j<1||j>7.4[0].q){8 w}8 7.4[i-1][j-1]},33:l(i){o(i>7.4.q){8 w}8 v.u(7.4[i-1])},2E:l(j){o(j>7.4[0].q){8 w}9 a=[],n=7.4.q,k=n,i;J{i=k-n;a.19(7.4[i][j-1])}H(--n);8 v.u(a)},2R:l(){8{2D:7.4.q,1p:7.4[0].q}},2D:l(){8 7.4.q},1p:l(){8 7.4[0].q},24:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}o(7.4.q!=M.q||7.4[0].q!=M[0].q){8 1L}9 b=7.4.q,15=b,i,G,10=7.4[0].q,j;J{i=15-b;G=10;J{j=10-G;o(F.13(7.4[i][j]-M[i][j])>17.16){8 1L}}H(--G)}H(--b);8 2x},1q:l(){8 S.u(7.4)},1b:l(a){9 b=[],12=7.4.q,15=12,i,G,10=7.4[0].q,j;J{i=15-12;G=10;b[i]=[];J{j=10-G;b[i][j]=a(7.4[i][j],i+1,j+1)}H(--G)}H(--12);8 S.u(b)},2i:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}8(7.4.q==M.q&&7.4[0].q==M[0].q)},2j:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}o(!7.2i(M)){8 w}8 7.1b(l(x,i,j){8 x+M[i-1][j-1]})},2C:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}o(!7.2i(M)){8 w}8 7.1b(l(x,i,j){8 x-M[i-1][j-1]})},2B:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}8(7.4[0].q==M.q)},22:l(a){o(!a.4){8 7.1b(l(x){8 x*a})}9 b=a.1u?2x:1L;9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}o(!7.2B(M)){8 w}9 d=7.4.q,15=d,i,G,10=M[0].q,j;9 e=7.4[0].q,4=[],21,20,c;J{i=15-d;4[i]=[];G=10;J{j=10-G;21=0;20=e;J{c=e-20;21+=7.4[i][c]*M[c][j]}H(--20);4[i][j]=21}H(--G)}H(--d);9 M=S.u(4);8 b?M.2E(1):M},x:l(a){8 7.22(a)},32:l(a,b,c,d){9 e=[],12=c,i,G,j;9 f=7.4.q,1p=7.4[0].q;J{i=c-12;e[i]=[];G=d;J{j=d-G;e[i][j]=7.4[(a+i-1)%f][(b+j-1)%1p]}H(--G)}H(--12);8 S.u(e)},31:l(){9 a=7.4.q,1p=7.4[0].q;9 b=[],12=1p,i,G,j;J{i=1p-12;b[i]=[];G=a;J{j=a-G;b[i][j]=7.4[j][i]}H(--G)}H(--12);8 S.u(b)},1y:l(){8(7.4.q==7.4[0].q)},2A:l(){9 m=0,12=7.4.q,15=12,i,G,10=7.4[0].q,j;J{i=15-12;G=10;J{j=10-G;o(F.13(7.4[i][j])>F.13(m)){m=7.4[i][j]}}H(--G)}H(--12);8 m},2Z:l(x){9 a=w,12=7.4.q,15=12,i,G,10=7.4[0].q,j;J{i=15-12;G=10;J{j=10-G;o(7.4[i][j]==x){8{i:i+1,j:j+1}}}H(--G)}H(--12);8 w},30:l(){o(!7.1y){8 w}9 a=[],n=7.4.q,k=n,i;J{i=k-n;a.19(7.4[i][i])}H(--n);8 v.u(a)},1K:l(){9 M=7.1q(),1c;9 n=7.4.q,k=n,i,1s,1n=7.4[0].q,p;J{i=k-n;o(M.4[i][i]==0){2e(j=i+1;j<k;j++){o(M.4[j][i]!=0){1c=[];1s=1n;J{p=1n-1s;1c.19(M.4[i][p]+M.4[j][p])}H(--1s);M.4[i]=1c;1I}}}o(M.4[i][i]!=0){2e(j=i+1;j<k;j++){9 a=M.4[j][i]/M.4[i][i];1c=[];1s=1n;J{p=1n-1s;1c.19(p<=i?0:M.4[j][p]-M.4[i][p]*a)}H(--1s);M.4[j]=1c}}}H(--n);8 M},3h:l(){8 7.1K()},2z:l(){o(!7.1y()){8 w}9 M=7.1K();9 a=M.4[0][0],n=M.4.q-1,k=n,i;J{i=k-n+1;a=a*M.4[i][i]}H(--n);8 a},3f:l(){8 7.2z()},2y:l(){8(7.1y()&&7.2z()===0)},2Y:l(){o(!7.1y()){8 w}9 a=7.4[0][0],n=7.4.q-1,k=n,i;J{i=k-n+1;a+=7.4[i][i]}H(--n);8 a},3e:l(){8 7.2Y()},1Y:l(){9 M=7.1K(),1Y=0;9 a=7.4.q,15=a,i,G,10=7.4[0].q,j;J{i=15-a;G=10;J{j=10-G;o(F.13(M.4[i][j])>17.16){1Y++;1I}}H(--G)}H(--a);8 1Y},3d:l(){8 7.1Y()},2W:l(a){9 M=a.4||a;o(1g(M[0][0])==\'1f\'){M=S.u(M).4}9 T=7.1q(),1p=T.4[0].q;9 b=T.4.q,15=b,i,G,10=M[0].q,j;o(b!=M.q){8 w}J{i=15-b;G=10;J{j=10-G;T.4[i][1p+j]=M[i][j]}H(--G)}H(--b);8 T},2w:l(){o(!7.1y()||7.2y()){8 w}9 a=7.4.q,15=a,i,j;9 M=7.2W(S.I(a)).1K();9 b,1n=M.4[0].q,p,1c,2v;9 c=[],2c;J{i=a-1;1c=[];b=1n;c[i]=[];2v=M.4[i][i];J{p=1n-b;2c=M.4[i][p]/2v;1c.19(2c);o(p>=15){c[i].19(2c)}}H(--b);M.4[i]=1c;2e(j=0;j<i;j++){1c=[];b=1n;J{p=1n-b;1c.19(M.4[j][p]-M.4[i][p]*M.4[j][i])}H(--b);M.4[j]=1c}}H(--a);8 S.u(c)},3c:l(){8 7.2w()},2d:l(){8 7.1b(l(x){8 F.2d(x)})},2V:l(x){8 7.1b(l(p){8(F.13(p-x)<=17.16)?x:p})},2n:l(){9 a=[];9 n=7.4.q,k=n,i;J{i=k-n;a.19(v.u(7.4[i]).2n())}H(--n);8 a.2K(\'\\n\')},26:l(a){9 i,4=a.4||a;o(1g(4[0][0])!=\'1f\'){9 b=4.q,15=b,G,10,j;7.4=[];J{i=15-b;G=4[i].q;10=G;7.4[i]=[];J{j=10-G;7.4[i][j]=4[i][j]}H(--G)}H(--b);8 7}9 n=4.q,k=n;7.4=[];J{i=k-n;7.4.19([4[i]])}H(--n);8 7}};S.u=l(a){9 M=25 S();8 M.26(a)};S.I=l(n){9 a=[],k=n,i,G,j;J{i=k-n;a[i]=[];G=k;J{j=k-G;a[i][j]=(i==j)?1:0}H(--G)}H(--n);8 S.u(a)};S.2X=l(a){9 n=a.q,k=n,i;9 M=S.I(n);J{i=k-n;M.4[i][i]=a[i]}H(--n);8 M};S.1R=l(b,a){o(!a){8 S.u([[F.1H(b),-F.1G(b)],[F.1G(b),F.1H(b)]])}9 d=a.1q();o(d.4.q!=3){8 w}9 e=d.1u();9 x=d.4[0]/e,y=d.4[1]/e,z=d.4[2]/e;9 s=F.1G(b),c=F.1H(b),t=1-c;8 S.u([[t*x*x+c,t*x*y-s*z,t*x*z+s*y],[t*x*y+s*z,t*y*y+c,t*y*z-s*x],[t*x*z-s*y,t*y*z+s*x,t*z*z+c]])};S.3b=l(t){9 c=F.1H(t),s=F.1G(t);8 S.u([[1,0,0],[0,c,-s],[0,s,c]])};S.39=l(t){9 c=F.1H(t),s=F.1G(t);8 S.u([[c,0,s],[0,1,0],[-s,0,c]])};S.38=l(t){9 c=F.1H(t),s=F.1G(t);8 S.u([[c,-s,0],[s,c,0],[0,0,1]])};S.2J=l(n,m){8 S.1j(n,m).1b(l(){8 F.2F()})};S.1j=l(n,m){9 a=[],12=n,i,G,j;J{i=n-12;a[i]=[];G=m;J{j=m-G;a[i][j]=0}H(--G)}H(--12);8 S.u(a)};l 14(){}14.23={24:l(a){8(7.1m(a)&&7.1h(a.K))},1q:l(){8 14.u(7.K,7.U)},2U:l(a){9 V=a.4||a;8 14.u([7.K.4[0]+V[0],7.K.4[1]+V[1],7.K.4[2]+(V[2]||0)],7.U)},1m:l(a){o(a.W){8 a.1m(7)}9 b=7.U.1C(a.U);8(F.13(b)<=17.16||F.13(b-F.1A)<=17.16)},1o:l(a){o(a.W){8 a.1o(7)}o(a.U){o(7.1m(a)){8 7.1o(a.K)}9 N=7.U.2f(a.U).2q().4;9 A=7.K.4,B=a.K.4;8 F.13((A[0]-B[0])*N[0]+(A[1]-B[1])*N[1]+(A[2]-B[2])*N[2])}1d{9 P=a.4||a;9 A=7.K.4,D=7.U.4;9 b=P[0]-A[0],2a=P[1]-A[1],29=(P[2]||0)-A[2];9 c=F.1x(b*b+2a*2a+29*29);o(c===0)8 0;9 d=(b*D[0]+2a*D[1]+29*D[2])/c;9 e=1-d*d;8 F.13(c*F.1x(e<0?0:e))}},1h:l(a){9 b=7.1o(a);8(b!==w&&b<=17.16)},2T:l(a){8 a.1h(7)},1v:l(a){o(a.W){8 a.1v(7)}8(!7.1m(a)&&7.1o(a)<=17.16)},1U:l(a){o(a.W){8 a.1U(7)}o(!7.1v(a)){8 w}9 P=7.K.4,X=7.U.4,Q=a.K.4,Y=a.U.4;9 b=X[0],1z=X[1],1B=X[2],1T=Y[0],1S=Y[1],1M=Y[2];9 c=P[0]-Q[0],2s=P[1]-Q[1],2r=P[2]-Q[2];9 d=-b*c-1z*2s-1B*2r;9 e=1T*c+1S*2s+1M*2r;9 f=b*b+1z*1z+1B*1B;9 g=1T*1T+1S*1S+1M*1M;9 h=b*1T+1z*1S+1B*1M;9 k=(d*g/f+h*e)/(g-h*h);8 v.u([P[0]+k*b,P[1]+k*1z,P[2]+k*1B])},1r:l(a){o(a.U){o(7.1v(a)){8 7.1U(a)}o(7.1m(a)){8 w}9 D=7.U.4,E=a.U.4;9 b=D[0],1l=D[1],1k=D[2],1P=E[0],1O=E[1],1Q=E[2];9 x=(1k*1P-b*1Q),y=(b*1O-1l*1P),z=(1l*1Q-1k*1O);9 N=v.u([x*1Q-y*1O,y*1P-z*1Q,z*1O-x*1P]);9 P=11.u(a.K,N);8 P.1U(7)}1d{9 P=a.4||a;o(7.1h(P)){8 v.u(P)}9 A=7.K.4,D=7.U.4;9 b=D[0],1l=D[1],1k=D[2],1w=A[0],18=A[1],1a=A[2];9 x=b*(P[1]-18)-1l*(P[0]-1w),y=1l*((P[2]||0)-1a)-1k*(P[1]-18),z=1k*(P[0]-1w)-b*((P[2]||0)-1a);9 V=v.u([1l*x-1k*z,1k*y-b*x,b*z-1l*y]);9 k=7.1o(P)/V.1u();8 v.u([P[0]+V.4[0]*k,P[1]+V.4[1]*k,(P[2]||0)+V.4[2]*k])}},1V:l(t,a){o(1g(a.U)==\'1f\'){a=14.u(a.1N(),v.k)}9 R=S.1R(t,a.U).4;9 C=a.1r(7.K).4;9 A=7.K.4,D=7.U.4;9 b=C[0],1E=C[1],1J=C[2],1w=A[0],18=A[1],1a=A[2];9 x=1w-b,y=18-1E,z=1a-1J;8 14.u([b+R[0][0]*x+R[0][1]*y+R[0][2]*z,1E+R[1][0]*x+R[1][1]*y+R[1][2]*z,1J+R[2][0]*x+R[2][1]*y+R[2][2]*z],[R[0][0]*D[0]+R[0][1]*D[1]+R[0][2]*D[2],R[1][0]*D[0]+R[1][1]*D[1]+R[1][2]*D[2],R[2][0]*D[0]+R[2][1]*D[1]+R[2][2]*D[2]])},1t:l(a){o(a.W){9 A=7.K.4,D=7.U.4;9 b=A[0],18=A[1],1a=A[2],2N=D[0],1l=D[1],1k=D[2];9 c=7.K.1t(a).4;9 d=b+2N,2h=18+1l,2o=1a+1k;9 Q=a.1r([d,2h,2o]).4;9 e=[Q[0]+(Q[0]-d)-c[0],Q[1]+(Q[1]-2h)-c[1],Q[2]+(Q[2]-2o)-c[2]];8 14.u(c,e)}1d o(a.U){8 7.1V(F.1A,a)}1d{9 P=a.4||a;8 14.u(7.K.1t([P[0],P[1],(P[2]||0)]),7.U)}},1Z:l(a,b){a=v.u(a);b=v.u(b);o(a.4.q==2){a.4.19(0)}o(b.4.q==2){b.4.19(0)}o(a.4.q>3||b.4.q>3){8 w}9 c=b.1u();o(c===0){8 w}7.K=a;7.U=v.u([b.4[0]/c,b.4[1]/c,b.4[2]/c]);8 7}};14.u=l(a,b){9 L=25 14();8 L.1Z(a,b)};14.X=14.u(v.1j(3),v.i);14.Y=14.u(v.1j(3),v.j);14.Z=14.u(v.1j(3),v.k);l 11(){}11.23={24:l(a){8(7.1h(a.K)&&7.1m(a))},1q:l(){8 11.u(7.K,7.W)},2U:l(a){9 V=a.4||a;8 11.u([7.K.4[0]+V[0],7.K.4[1]+V[1],7.K.4[2]+(V[2]||0)],7.W)},1m:l(a){9 b;o(a.W){b=7.W.1C(a.W);8(F.13(b)<=17.16||F.13(F.1A-b)<=17.16)}1d o(a.U){8 7.W.2k(a.U)}8 w},2k:l(a){9 b=7.W.1C(a.W);8(F.13(F.1A/2-b)<=17.16)},1o:l(a){o(7.1v(a)||7.1h(a)){8 0}o(a.K){9 A=7.K.4,B=a.K.4,N=7.W.4;8 F.13((A[0]-B[0])*N[0]+(A[1]-B[1])*N[1]+(A[2]-B[2])*N[2])}1d{9 P=a.4||a;9 A=7.K.4,N=7.W.4;8 F.13((A[0]-P[0])*N[0]+(A[1]-P[1])*N[1]+(A[2]-(P[2]||0))*N[2])}},1h:l(a){o(a.W){8 w}o(a.U){8(7.1h(a.K)&&7.1h(a.K.2j(a.U)))}1d{9 P=a.4||a;9 A=7.K.4,N=7.W.4;9 b=F.13(N[0]*(A[0]-P[0])+N[1]*(A[1]-P[1])+N[2]*(A[2]-(P[2]||0)));8(b<=17.16)}},1v:l(a){o(1g(a.U)==\'1f\'&&1g(a.W)==\'1f\'){8 w}8!7.1m(a)},1U:l(a){o(!7.1v(a)){8 w}o(a.U){9 A=a.K.4,D=a.U.4,P=7.K.4,N=7.W.4;9 b=(N[0]*(P[0]-A[0])+N[1]*(P[1]-A[1])+N[2]*(P[2]-A[2]))/(N[0]*D[0]+N[1]*D[1]+N[2]*D[2]);8 v.u([A[0]+D[0]*b,A[1]+D[1]*b,A[2]+D[2]*b])}1d o(a.W){9 c=7.W.2f(a.W).2q();9 N=7.W.4,A=7.K.4,O=a.W.4,B=a.K.4;9 d=S.1j(2,2),i=0;H(d.2y()){i++;d=S.u([[N[i%3],N[(i+1)%3]],[O[i%3],O[(i+1)%3]]])}9 e=d.2w().4;9 x=N[0]*A[0]+N[1]*A[1]+N[2]*A[2];9 y=O[0]*B[0]+O[1]*B[1]+O[2]*B[2];9 f=[e[0][0]*x+e[0][1]*y,e[1][0]*x+e[1][1]*y];9 g=[];2e(9 j=1;j<=3;j++){g.19((i==j)?0:f[(j+(5-i)%3)%3])}8 14.u(g,c)}},1r:l(a){9 P=a.4||a;9 A=7.K.4,N=7.W.4;9 b=(A[0]-P[0])*N[0]+(A[1]-P[1])*N[1]+(A[2]-(P[2]||0))*N[2];8 v.u([P[0]+N[0]*b,P[1]+N[1]*b,(P[2]||0)+N[2]*b])},1V:l(t,a){9 R=S.1R(t,a.U).4;9 C=a.1r(7.K).4;9 A=7.K.4,N=7.W.4;9 b=C[0],1E=C[1],1J=C[2],1w=A[0],18=A[1],1a=A[2];9 x=1w-b,y=18-1E,z=1a-1J;8 11.u([b+R[0][0]*x+R[0][1]*y+R[0][2]*z,1E+R[1][0]*x+R[1][1]*y+R[1][2]*z,1J+R[2][0]*x+R[2][1]*y+R[2][2]*z],[R[0][0]*N[0]+R[0][1]*N[1]+R[0][2]*N[2],R[1][0]*N[0]+R[1][1]*N[1]+R[1][2]*N[2],R[2][0]*N[0]+R[2][1]*N[1]+R[2][2]*N[2]])},1t:l(a){o(a.W){9 A=7.K.4,N=7.W.4;9 b=A[0],18=A[1],1a=A[2],2M=N[0],2L=N[1],2Q=N[2];9 c=7.K.1t(a).4;9 d=b+2M,2p=18+2L,2m=1a+2Q;9 Q=a.1r([d,2p,2m]).4;9 e=[Q[0]+(Q[0]-d)-c[0],Q[1]+(Q[1]-2p)-c[1],Q[2]+(Q[2]-2m)-c[2]];8 11.u(c,e)}1d o(a.U){8 7.1V(F.1A,a)}1d{9 P=a.4||a;8 11.u(7.K.1t([P[0],P[1],(P[2]||0)]),7.W)}},1Z:l(a,b,c){a=v.u(a);a=a.1N();o(a===w){8 w}b=v.u(b);b=b.1N();o(b===w){8 w}o(1g(c)==\'1f\'){c=w}1d{c=v.u(c);c=c.1N();o(c===w){8 w}}9 d=a.4[0],18=a.4[1],1a=a.4[2];9 e=b.4[0],1W=b.4[1],1X=b.4[2];9 f,1i;o(c!==w){9 g=c.4[0],2l=c.4[1],2t=c.4[2];f=v.u([(1W-18)*(2t-1a)-(1X-1a)*(2l-18),(1X-1a)*(g-d)-(e-d)*(2t-1a),(e-d)*(2l-18)-(1W-18)*(g-d)]);1i=f.1u();o(1i===0){8 w}f=v.u([f.4[0]/1i,f.4[1]/1i,f.4[2]/1i])}1d{1i=F.1x(e*e+1W*1W+1X*1X);o(1i===0){8 w}f=v.u([b.4[0]/1i,b.4[1]/1i,b.4[2]/1i])}7.K=a;7.W=f;8 7}};11.u=l(a,b,c){9 P=25 11();8 P.1Z(a,b,c)};11.2I=11.u(v.1j(3),v.k);11.2H=11.u(v.1j(3),v.i);11.2G=11.u(v.1j(3),v.j);11.36=11.2I;11.35=11.2H;11.3j=11.2G;9 $V=v.u;9 $M=S.u;9 $L=14.u;9 $P=11.u;', 62, 206, '||||elements|||this|return|var||||||||||||function|||if||length||||create|Vector|null|||||||||Math|nj|while||do|anchor||||||||Matrix||direction||normal||||kj|Plane|ni|abs|Line|ki|precision|Sylvester|A2|push|A3|map|els|else||undefined|typeof|contains|mod|Zero|D3|D2|isParallelTo|kp|distanceFrom|cols|dup|pointClosestTo|np|reflectionIn|modulus|intersects|A1|sqrt|isSquare|X2|PI|X3|angleFrom|mod1|C2|mod2|sin|cos|break|C3|toRightTriangular|false|Y3|to3D|E2|E1|E3|Rotation|Y2|Y1|intersectionWith|rotate|v12|v13|rank|setVectors|nc|sum|multiply|prototype|eql|new|setElements|case|each|PA3|PA2|part|new_element|round|for|cross|product|AD2|isSameSizeAs|add|isPerpendicularTo|v22|AN3|inspect|AD3|AN2|toUnitVector|PsubQ3|PsubQ2|v23|dot|divisor|inverse|true|isSingular|determinant|max|canMultiplyFromLeft|subtract|rows|col|random|ZX|YZ|XY|Random|join|N2|N1|D1|slice|default|N3|dimensions|switch|liesIn|translate|snapTo|augment|Diagonal|trace|indexOf|diagonal|transpose|minor|row|isAntiparallelTo|ZY|YX|acos|RotationZ|RotationY|liesOn|RotationX|inv|rk|tr|det|toDiagonalMatrix|toUpperTriangular|version|XZ'.split('|'), 0, {}))

var _T = {
    rotate: function (deg) {
        var rad = parseFloat(deg) * (Math.PI / 180),
            costheta = Math.cos(rad),
            sintheta = Math.sin(rad);

        var a = costheta,
            b = sintheta,
            c = -sintheta,
            d = costheta;

        return $M([
            [a, c, 0],
            [b, d, 0],
            [0, 0, 1]
        ]);
    },

    skew: function (dx, dy) {
        var radX = parseFloat(dx) * (Math.PI / 180),
            radY = parseFloat(dy) * (Math.PI / 180),
            c = Math.tan(radX),
            b = Math.tan(radY);


        return $M([
            [1, c, 0],
            [b, 1, 0],
            [0, 0, 1]
        ]);
    },

    translate: function (x, y) {
        var e = x || 0,
            f = y || 0;

        return $M([
            [1, 0, e],
            [0, 1, f],
            [0, 0, 1]
        ]);
    },

    scale: function (x, y) {
        var a = x || 0,
            d = y || 0;

        return $M([
            [a, 0, 0],
            [0, d, 0],
            [0, 0, 1]
        ]);
    },

    toString: function (m) {
        var s = 'matrix(',
            r, c;

        for (c = 1; c <= 3; c++) {
            for (r = 1; r <= 2; r++)
                s += m.e(r, c) + ', ';
        }

        s = s.substr(0, s.length - 2) + ')';

        return s;
    },

    fromString: function (s) {
        var t = /^matrix\((\S*), (\S*), (\S*), (\S*), (\S*), (\S*)\)$/g.exec(s),
            a = parseFloat(!t ? 1 : t[1]),
            b = parseFloat(!t ? 0 : t[2]),
            c = parseFloat(!t ? 0 : t[3]),
            d = parseFloat(!t ? 1 : t[4]),
            e = parseFloat(!t ? 0 : t[5]),
            f = parseFloat(!t ? 0 : t[6]);

        return $M([
            [a, c, e],
            [b, d, f],
            [0, 0, 1]
        ]);
    }
};


jQuery(function ($) {

    var console = window.console && NKS_DEBUG ? window.console : {
        log: function () {
        }
    }

    if (/MSIE 8/.test(navigator.userAgent)) {
        return
    }

    $(window.NKS_CC_Opts.selectors).addClass("nks_cc_trigger_element");

    //if ($('body').is('.admin-bar')) { $('html').attr('style', 'margin-top: 0 !important'); };

    // main logic, human readable
    setTimeout(function () {

        var NinjaSidebarCustom = window.NinjaSidebarCustom || (function () {
                var opts = window.NKS_CC_Opts;

                var TYPE = opts.sidebar_type;

                // caching
                var $win = $(window);
                var $html = $('html');
                var b = document.body;
                var $body = $('body');
                var $tabs = $('.nks_cc_trigger_tabs').not('.ncf_tab');
                var $overlay = $('#nks-overlay-wrapper').appendTo($body);
                var $overlayIn = $overlay.children();
                var $sidebar = $('#nks_cc_sidebar');
                var $scrollable = $sidebar.find('.nks_cc_sidebar_cont_scrollable');
                var $cont = $sidebar.find('.nks_cc_sidebar_cont');
                var transProp = getVendorPropertyName('transform');
                var $bodybg;
                var $bodychildren;
                var bodyCss;

                var direction = opts.sidebar_pos;
                var sidebarW = parseInt(opts.width, 10);
                var opposite = direction === 'left' ? 'right' : 'left';
                var translation = _T.translate((direction === 'left' ? sidebarW : -sidebarW), 0);
                var defTranslationStr = _T.toString(_T.translate(0, 0));
                var currentW = $win.width();
                var htmlMargins = {
                    top: parseInt($html.css('marginTop')),
                    bottom: parseInt($html.css('marginBottom'))
                }

                console.log(transProp)


                var webkit = /safari|chrome/.test(navigator.userAgent.toLowerCase());
                var isMobile = /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
                var isAnimated = false;
                var isExposed = false;
                var isIE = false;
                var _h = 0;
                var isFF = /firefox/.test(navigator.userAgent.toLowerCase());

                if (NKS_DEBUG) {
//				$('<div id="nks-fixed">').prependTo('#container');
//			  $('<div id="nks-fixed2">').appendTo('#footer #footer-wrapper');
//			  $('<div id="nks-fixed-bg">').appendTo($body);
                }

                $bodychildren = $body.children().not('#nks-body-bg, #nks_cc_sidebar, script, style').filter(':visible');

                for (var prop in htmlMargins) {
                    if (isNaN(htmlMargins[prop])) {
                        htmlMargins[prop] = 0;
                    }
                }

                //$sidebar.after('<div id="nks-body-bg"></div>');
                $bodybg = $('#nks-body-bg');

                // LEGACY
                if (TYPE === 'push' && false) {

                    if (htmlMargins.top) {
                        //$body.css('top', htmlMargins.top);
                        //$html.attr('style', 'margin-top: 0!important')
                    }

                    bodyCss = {
                        'backgroundColor': $body.css('backgroundColor'),
                        'backgroundImage': $body.css('backgroundImage'),
                        'backgroundAttachment': $body.css('backgroundAttachment'),
                        'backgroundSize': $body.css('backgroundSize'),
                        'backgroundPosition': $body.css('backgroundPosition'),
                        'backgroundRepeat': $body.css('backgroundRepeat'),
                        'backgroundOrigin': $body.css('backgroundOrigin'),
                        'backgroundClip': $body.css('backgroundClip')
                    };

                    if (bodyCss.backgroundColor.indexOf('(0, 0, 0, 0') + 1 || bodyCss.backgroundColor.indexOf('transparent') + 1) {
                        bodyCss.backgroundColor = '#fff';
                    }

                    console.log(bodyCss.backgroundPosition)

                    if (bodyCss.backgroundAttachment === 'fixed') {
                        bodyCss.position = 'fixed';
                        bodyCss.backgroundAttachment = 'scroll';
                    }

                    if (parseInt($bodychildren.first().css('marginTop')) || parseInt($bodychildren.last().css('marginBottom'))) {
                        $body.addClass('nks-body-float');
                    }

                    $bodybg.css(bodyCss);
                }


                $bodychildren.each(function (i, el) {
                    var $t = $(this);
                    var z;
                    var pos = $t.css('position');

                    if (pos === 'fixed') {
                        z = $t.css('zIndex');
                        if (z !== 'auto' && z < 0) {
                            $t.insertAfter($bodybg).css('zIndex', 0);
                        }
                    }

//				if (pos !== 'fixed' && pos !== 'absolute') {
//					_h += $t[0].scrollHeight;
//				}
                });

                function init() {

                    $('.nks_cc_trigger_element, .nks_cc_trigger_tabs span.nks-tab').on('click touchstart', function (e) {
                        console.log(this)
                        var $t = $(this);

                        if ($t.data('nks-href')) {
                            location.href = $t.data('nks-href');
                            return;
                        }

                        var html = $t.data('NKS-html');
                        if (isExposed) hideSidebar($t)
                        else showSidebar(html, $t);
                        return false;
                    })

                    $overlayIn.click(function () {
                        hideSidebar()
                    });

                    var bodyClasses = 'nks_cc_hidden nks_cc_on nks_sidebar_' + TYPE + ' nks_cc_sidebar_pos_' + direction;
                    if (opts.label_no_anim === 'yes') bodyClasses += ' nks_label_no_anim';
                    if (/msie|trident.*rv\:11\./.test(navigator.userAgent.toLowerCase())) {
                        bodyClasses += ' nks_msie';
                        isIE = true;
                    }

                    if (webkit) {
                        bodyClasses += ' nks_webkit'
                    }

                    if (isMobile) {
                        bodyClasses += ' nks_mobile';
                    }
                    $body.addClass(bodyClasses);

                    $(document).ajaxComplete(function () {
                        setTimeout(function () {
                            if (!$body.is('.nks_cc_on')) {
                                $body.addClass(bodyClasses + (isExposed ? ' nks_cc_exposed' : ''));
                            }
                        }, 0);
                    });

                    if (opts.label_vis === 'scroll') {
                        $win.one('scroll', function () {
                            $tabs.removeClass('nks_cc_label_scroll')
                        });
                    } else if (opts.label_scroll_selector && opts.label_vis === 'scroll_into') {
                        var $elToScroll = $(opts.label_scroll_selector).eq(0);
                        $win.scroll(function () {
                            if (isExposed) return;
                            isScrolledIntoView($elToScroll) ? $tabs.removeClass('nks_cc_label_scroll_into') : $tabs.addClass('nks_cc_label_scroll_into')
                        }).scroll();
                    }

                    $win.resize(resize);
                    $cont.css({minHeight: $cont.height()});
                    if (isMobile) attachSwipesHandler();

                    if (window.transitionEnd) {
                        (TYPE === 'push' ? $bodybg : $sidebar).bind(window.transitionEnd, function (e) {
                            var $fixed;

                            if (!$(e.target).is((TYPE === 'push' ? $bodybg : $sidebar))) return;

                            if ($body.is('.nks_cc_exposed')) {

                                if (isMobile) setTimeout(function () {
                                    $sidebar.css('-webkit-overflow-scrolling', 'touch')
                                }, 100);
                                isExposed = true;

                            } else {

                                $body.unbind('mousewheel DOMMouseScroll', freezeBody);
                                $cont.css({'transform': '', 'margin': '', 'width': ''});
                                $body.addClass('nks_cc_hidden').find('.nks-active').removeClass('nks-active');
                                if (isMobile) $sidebar.css('-webkit-overflow-scrolling', '');
                                $overlay.css('visibility', 'hidden');
                                isExposed = false;

                                $fixed = $('.nks_fixed_inner_el')
                                if (!isIE && TYPE === 'push') $fixed.each(unshiftFixed);
                                $fixed.removeClass('nks_fixed_inner_el');

                            }
                            $body.removeClass('nks_cc_transitioning')
                            isAnimated = false;
                        });
                    } else {

                    }

                    $('.nks-tab').mouseenter(function () {
                        var $t = $(this);
                        $t.addClass('nks-hover');
                        //if (isExposed /*&& !$t.is('.nks-active')*/) $t.parent().addClass('nks-hover')
                    }).mouseleave(function () {
                        $(this).removeClass('nks-hover');
                        //if (isExposed) $(this).parent().removeClass('nks-hover')
                    })

                    if (TYPE === 'push' && !opts.isBgFixed) {

                        /*_h = Math.max(
                         b.scrollHeight, document.documentElement.scrollHeight,
                         b.offsetHeight, document.documentElement.offsetHeight,
                         b.clientHeight, document.documentElement.clientHeight
                         )*/

                        //_h = _h - htmlMargins.top - htmlMargins.bottom;
                        //$bodybg.height(_h);

                    }
                    $bodybg.add($sidebar).add($tabs).show();

                    NinjaSidebarCustom.init = function () {
                    };
                    return this;
                }

                function showSidebar(htmlOrNum, $el) {

                    console.log('showSidebar', 'isAnimated: ' + isAnimated, 'isExposed: ' + isExposed)

                    if (isAnimated || isExposed) return;
                    else isAnimated = true;

                    var ww;
                    var _tr;
                    var css;
                    var $active;
                    var $children;
                    var tab;

                    if (typeof htmlOrNum === 'string') {
                        $active = $cont.find('[id*=nks-content]').first()
                        $active.html(htmlOrNum);
                        $active.add($('[id*=nks-tab]').first()).addClass('nks-active');
                    } else if (typeof htmlOrNum === 'number') {
                        $active = $cont.find('#nks-content-' + htmlOrNum);
                        $active.add($('#nks-tab-' + htmlOrNum)).addClass('nks-active');
                    }


                    if ($el) {
                        if ($el.data('link')) {
                            location.href = $el.data('link');
                            return;
                        }
                        if ($el.is('.nks-tab')) {
                            $active = $cont.find('#' + $el.attr('id').replace('tab', 'content'));
                            $active.add($el).addClass('nks-active');
                        } else {
                            tab = $el.attr('class').match(/nks_toggle_tab_(\d+)/);
                            tab = tab ? tab[1] : 1;
                            $active = $cont.find('#nks-content-' + tab);
                            $active.add($('#nks-tab-' + tab)).addClass('nks-active');
                        }
                        $scrollable.scrollTop(0);
                    }


                    $('.nks-tab').mouseleave();

                    $scrollable.bind('mousewheel DOMMouseScroll', freezeBodyScroll);

                    ww = window.innerWidth || $win.width();
                    $children = $body.children().not('#nks_cc_sidebar, #sfm-sidebar, [id*=ncf], script, style');

                    if (ww < sidebarW + 60) {
                        if (TYPE === 'push') {
                            $sidebar.width(ww);
                            $cont.width(ww - 60);
                            _tr = _T.translate((direction === 'left' ? ww - 60 : 60 - ww), 0);

                            $children.add().each(function () {
                                var $el = $(this);
                                var t = $el.css(transProp);
                                var n;
                                if (t !== 'none') {
                                    $el.data('nks-old-matrix', t);
                                    t = _T.fromString(t);
                                    n = t.x(_tr); // add translation
                                    css = {};
                                    css[transProp] = _T.toString(n);
                                    $el.css(css).data('nks-transformed', 1);
                                } else {
                                    css = {};
                                    css[transProp] = _T.toString(_tr);
                                    $el.css(css).data('nks-transformed', 1);
                                }
                            })
                        } else {
                            $sidebar.width(ww - 60);
                            css = {};
                            css[transProp] = _T.toString(_T.translate((direction === 'left' ? ww - 65 : 65 - ww), 0));
                            $tabs.css(css).data('nks-adjusted', 1)
                        }
                    }

                    if (TYPE === 'push') {
                        $children.each(function () {
                            var $el = $(this);
                            var t = $el.css(transProp);
                            var n;
                            if (t !== 'none' && !$el.data('nks-transformed')) {
                                $el.data('nks-old-matrix', t);
                                t = _T.fromString(t);
                                n = t.x(translation); // add translation
                                css = {};
                                css[transProp] = _T.toString(n);
                                $el.css(css);
                            }
                        });
                    }

                    $body
                        .removeClass('nks_cc_hidden')
                        .addClass('nks_cc_exposed nks_cc_transitioning')
                        .bind('mousewheel DOMMouseScroll', freezeBody); //

                    if (TYPE === 'push') {
                        $children.find('*').each(function (i, el) {
                            shiftFixed(i, el, $win.scrollTop(), $win.scrollLeft())
                        });
                    }

                    $overlay.css('visibility', 'visible');

                    $cont.find('.nks-active .nks-shrinked').removeClass('nks-shrinked')

                    if ($.fn.layerSlider) $('div[id*=layerslider]').layerSlider('stop');
                    if ($.fn.revpause) $('.rev_slider').revpause();

                    if (!window.transitionEnd) {
                        setTimeout(function () {
                            $body.removeClass('nks_cc_transitioning')
                            isAnimated = false;
                            //if (isMobile) $sidebar.css('-webkit-overflow-scrolling', 'touch');
                            isExposed = true;
                        }, 400)

                    }
                }

                function hideSidebar($el) {

                    console.log('hideSidebar', 'isAnimated: ' + isAnimated, 'isExposed: ' + isExposed)

                    var $fixed;
                    var $active;
                    var tab;

                    if ($el) {

                        if ($el.is('.nks-tab') && !$el.is('.nks-active')) {
                            $active = $cont.find('#' + $el.attr('id').replace('tab', 'content'));
                            $body.find('.nks-active').removeClass('nks-active');
                            $active.add($el).addClass('nks-active');
                            $active.find('.nks-shrinked').removeClass('nks-shrinked')
                            $scrollable.scrollTop(0);
                            return false;
                        }
                        else if ($el.parents('#nks_cc_sidebar').length) {
                            tab = $el.attr('class').match(/nks_toggle_tab_(\d+)/);
                            tab = tab ? tab[1] : 1;
                            $active = $cont.find('#nks-content-' + tab);
                            $body.find('.nks-active').removeClass('nks-active');
                            $active.add($('#nks-tab-' + tab)).addClass('nks-active');
                            $scrollable.scrollTop(0);
                            return false;
                        }
                    }

                    if (isAnimated || !isExposed) return
                    else isAnimated = true;

                    $scrollable.unbind('mousewheel DOMMouseScroll', freezeBodyScroll);

                    $body.removeClass('nks_cc_exposed').addClass('nks_cc_transitioning');

                    if ($tabs.data('nks-adjusted')) $tabs.css(transProp, '').data('nks-adjusted', '')

                    if (TYPE === 'push') {
                        $body.children().not('#nks_cc_sidebar, script, style').each(function () {
                            var $el = $(this);
                            if ($el.data('nks-old-matrix')) {
                                $el.css(transProp, $el.data('nks-old-matrix')).data('nks-old-matrix', '');
                            } else {
                                $el.css(transProp, '').data('nks-transformed', '');
                            }
                        })
                    }

                    $fixed = $('.nks_fixed_inner_el');
                    if (isIE && TYPE === 'push') $fixed.each(unshiftFixed);

//	     if ($.fn.layerSlider) $('div[id*=layerslider]').layerSlider('start');

                    $('.nks-tab').mouseleave();

                    console.log(window.transitionEnd)

                    if (!window.transitionEnd) {

                        if (TYPE === 'push') $fixed.each(unshiftFixed).removeClass('nks_fixed_inner_el');

                        setTimeout(function () {
                            console.log('no transition')
                            $body.unbind('mousewheel DOMMouseScroll', freezeBody).addClass('nks_cc_hidden');
                            $cont
                                .addClass('nks-shrinked')
                                .css({'transform': 'scale(1,1)', 'margin': '', 'width': ''});
                            $body.find('.nks-active').removeClass('nks-active');
                            if (isMobile) $sidebar.css('-webkit-overflow-scrolling', '');
                            $body.removeClass('nks_cc_transitioning');
                            $overlay.css('visibility', 'hidden');
                            isExposed = false;
                            isAnimated = false;
                        }, 0)
                    }
                }


                function shiftFixed(i, el, scrollTop, scrollLeft, bh, wh) {

                    var $t = $(el);
                    var $offsetP;
                    var t;
                    var nu;
                    var offset;
                    var oLeft;
                    var oTop;
                    var coords;
                    var newCSS;
                    var _b;
                    var transf;

                    if ($t.css('position') === 'fixed') {

                        $t.addClass('nks_fixed_inner_el')

                        if (isIE) {

                            t = $t.css(transProp);

                            if (t !== 'none') {
                                $t.data('nks-old-matrix', t);
                                t = _T.fromString(t);
                                nu = t.x(translation); // add translation
                                $t.css(transProp, _T.toString(nu)).data('nks-transformed', 1);
                            } else {
                                $t.css(transProp, _T.toString(translation)/*, transition: trans + 'transform 0.5s cubic-bezier(0.645, 0.045, 0.355, 1)', transitionDelay: '90ms'*/).data('nks-transformed', 1);
                            }

                        } else {

                            $offsetP = $t;

                            while ($offsetP = $offsetP.parent()) {
                                transf = $offsetP.css(transProp);

                                if ((transf && transf !== 'none') || $offsetP.is('body')) {
                                    break
                                }
                            }

                            offset = $offsetP.offset();
                            oLeft = offset.left;
                            oTop = offset.top;
//if (oTop === htmlMargins.top) oTop = 0;

                            if (isFF && $t.is(':visible')) {
                                $t.hide().data('nks-ff-hidden', 1);
                            }

                            coords = {
                                left: $t.css('left'),
                                right: $t.css('right'),
                                top: $t.css('top'),
                                bottom: $t.css('bottom')
                            }

                            if (isFF && $t.data('nks-ff-hidden')) $t.show();

                            newCSS = {};
                            _b = parseInt(coords.bottom);
                            _b = isNaN(_b) ? 0 : _b;

                            if (coords.left !== 'auto') {
                                coords.toChangeHor = 'left';
                                newCSS[coords.toChangeHor] = '-=' + (oLeft - scrollLeft);
                            } else if (coords.right !== 'auto') {
                                coords.toChangeHor = 'right';
                                newCSS[coords.toChangeHor] = '-=' + (oLeft - scrollLeft);
                            } else {
                                coords.toChangeHor = 'left'
                            }

                            if (coords.top !== 'auto') {
                                coords.toChangeVert = 'top';
                                newCSS[coords.toChangeVert] = oTop - scrollTop > 0 ? parseInt(coords.top) - (oTop - scrollTop) : parseInt(coords.top) + (scrollTop - oTop);
                            } else if (coords.bottom !== 'auto') {
                                coords.toChangeVert = 'bottom';
                                newCSS[coords.toChangeVert] = $body.height() + htmlMargins.top + htmlMargins.bottom + _b - $win.height() - scrollTop + 'px';
                            } else {
                                coords.toChangeVert = 'top';
                                newCSS[coords.toChangeVert] = scrollTop;
                            }
                            newCSS['transitionProperty'] = 'none';
//console.log($offsetP[0])
//						console.log(el, coords, newCSS, oTop, scrollTop)

                            $t.css(newCSS).data('nks-old-pos', coords)
                        }
                    }
                }

                function unshiftFixed(i, el) {
                    var $el = $(el);
                    var coords;
                    var newCss;
                    if (isIE) {
                        if ($el.data('nks-old-matrix')) {
                            $el.css(transProp, $el.data('nks-old-matrix')).data('nks-old-matrix', '');
                        } else {
                            $el.css(transProp, defTranslationStr).data('nks-transformed', '');
                        }
                    } else {
                        coords = $el.data('nks-old-pos');
                        newCss = {};
                        if (coords) {
                            newCss[coords.toChangeHor] = coords[coords.toChangeHor];
                            newCss[coords.toChangeVert] = coords[coords.toChangeVert];
                            newCss['transitionProperty'] = '';
                            if (coords.toChangeVert === 'bottom') newCss['top'] = '';
                            $el.css(newCss);
                            $el.data('nks-old-pos', '');
                        } else {
                            $el.css({left: '', top: '', bottom: '', right: '', 'transitionProperty': ''})
                        }
                    }
                }

                function isScrolledIntoView($elem) {
                    var docViewTop = $win.scrollTop();
                    var docViewBottom = docViewTop + $win.height();

                    var elemTop = $elem.offset().top;
                    var elemBottom = elemTop /*+ $elem.height()*/; // when element scrolls into view

                    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
                }

                function resize() {
                    var ww;
                    var $children;

                    if (isExposed) {

                        $children = $body.children().not('#nks_cc_sidebar, script, style');
                        ww = $win.width();

                        if (ww < sidebarW + 60) {

                            if (TYPE === 'push') {
                                $children.each(function () {
                                    var $el = $(this);
                                    var t = $el.css(transProp);
                                    var n;
                                    if (t !== 'none' && currentW !== ww) {
                                        $el.css(transProp, _T.toString(_T.translate(direction === 'left' ? ww - 60 : 60 - ww, 0)));
                                    }
                                });
                            }
                            $sidebar.width(ww);
                            $cont.width(ww - 60);

                        } else {

                            if (TYPE === 'push') {
                                $children.each(function () {
                                    var $el = $(this);
                                    $el.css(transProp, _T.toString(translation));
                                });
                                //$cont.css(transProp, 'scale(1,1)').css('margin', '');
                            }
                            $sidebar.add($cont).width('');
                        }
                        currentW = ww;

                    }

                    if (!opts.isBgFixed) {
                        $bodybg.css({'height': $body.outerHeight() /*+ htmlMargins.top, top: 0 - htmlMargins.top*/});
                    }
                }

                function attachSwipesHandler() {
                    var startX, startY, startTime, moveX, moveY;
                    $sidebar.add($overlayIn).bind('touchstart', function (e) {
                            if (isExposed) {
                                startTime = (new Date).getTime();
                                startX = e.originalEvent.touches[0].pageX;
                                startY = e.originalEvent.touches[0].clientY;
                            }
                        })
                        .bind('touchmove', function (e) {
                            if (isExposed) {
                                moveX = e.originalEvent.touches[0].pageX;
                                moveY = e.originalEvent.touches[0].clientY
                            }
                        })
                        .bind('touchend', function () {
                            if (isExposed) {
                                var swipeDirection = moveX > startX ? "right" : "left";
                                var finalY = moveY - startY > 30 || -30 > moveY - startY;
                                var finalX = moveX - startX > 60 || -60 > moveX - startX;
                                var now = (new Date).getTime();
                                if (!(now - startTime > 300 || finalY) && finalX) {
                                    switch (swipeDirection) {
                                        case "left":
                                            "left" === direction ? hideSidebar() : showSidebar();
                                            break;
                                        case "right":
                                            "left" === direction ? showSidebar() : hideSidebar()
                                    }
                                }
                            }
                        });
                }

                function freezeBodyScroll(e) {
                    var scrollTo = null;
                    if (e.type == 'mousewheel') {
                        scrollTo = (e.originalEvent.wheelDelta * -1);
                    }
                    else if (e.type == 'DOMMouseScroll') {
                        scrollTo = 40 * e.originalEvent.detail;
                    }

                    if (scrollTo) {
                        e.preventDefault();
                        $(this).scrollTop(scrollTo + $(this).scrollTop());
                    }
                }

                function freezeBody(e) {
                    if (e.type == 'mousewheel' || e.type == 'DOMMouseScroll') {
                        e.preventDefault()
                    }
                }

                return {
                    init: init,
                    showSidebar: showSidebar,
                    hideSidebar: hideSidebar
                }
            }());

        window.NinjaSidebarCustom = NinjaSidebarCustom.init();

    }, 0);

    function getVendorPropertyName(prop) {

        var prefixes = ['Moz', 'Webkit', 'O', 'ms'],
            vendorProp, i,
            div = document.createElement('div'),
            prop_ = prop.charAt(0).toUpperCase() + prop.substr(1);

        if (prop in div.style) {
            return prop;
        }

        for (i = 0; i < prefixes.length; ++i) {

            vendorProp = prefixes[i] + prop_;

            if (vendorProp in div.style) {
                return vendorProp;
            }

        }

        // Avoid memory leak in IE.
        this.div = null;
    };
});


